import { localLogger } from "./localLogger";
import { syncLiveUpdates } from "./sync";

/**
 * @example
 * ```ts
 * const versionNumber = await getCurrentBuild()
 * // "10145190 (Prod118)"    if the app is up-to-date
 * // "10145190 (Prod118) r"  "r" stands for "reload", indicating the app needs reloading.
 * ```
 */
export const getCurrentBuild = async () => {
  const info = await syncLiveUpdates();
  await localLogger.log(
    `getCurrentBuild -> info ${JSON.stringify(info, null, 2)}`
  );
  if (info.activeApplicationPathChanged) {
    localStorage.setItem("updateRequired", "true");
  }
  const channel =
    info?.liveUpdate?.channel && !info.liveUpdate.channel.startsWith("Prod")
      ? `(${info.liveUpdate.channel})`
      : "";
  const build = info?.snapshot?.buildId ?? "local";
  const versionNumber = `${build} ${channel} ${
    localStorage.getItem("updateRequired") === "true" ? "r" : ""
  }`;
  await localLogger.logDevice(versionNumber);
  return versionNumber;
};
